import styled from 'styled-components';
import { media } from '../utils/media';

export const Wrapper: any = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  line-height: 1.58;
  font-size: 20px;
  max-width: ${(props: any) => (props.fullWidth ? '100%' : '65rem')};
  padding: ${(props: any) => (props.fullWidth ? '0' : '0 1rem')};
  @media ${media.tablet} {
    padding: ${(props: any) => (props.fullWidth ? '0' : '0 3rem')};
  }
  @media ${media.desktop} {
    padding: ${(props: any) => (props.fullWidth ? '0' : '0 6rem')};
  }
`;
